// 繁体中文

export default {
  t1: '完成',
  t5: '支付',
  t6: '綁定並授權',
}
